var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-button back-to-top-button unvisible",class:`back-to-top-button--${_vm.$route.name}`,attrs:{"id":"back-to-top-button"},on:{"click":_vm.scrollToTop}},[_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }